export const LANGUAGES = ['en', 'ru', 'ua'];
